import { render, staticRenderFns } from "./Slides2.vue?vue&type=template&id=4775e9ae&lang=pug&"
import script from "./Slides2.vue?vue&type=script&lang=js&"
export * from "./Slides2.vue?vue&type=script&lang=js&"
import style0 from "./Slides2.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports